import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { monthMap } from '../../utils/calendar';
import { BookingStatisticFiltered } from '../../types/booking-statistic-filtered';
import { StatisticsVariant } from '../../types/statistic-variant';

type Props = {
  data: BookingStatisticFiltered;
  variant: StatisticsVariant;
};

export default function GeneralStatisticsTableRow({ data, variant }: Props) {
  const { t } = useTranslation();
  const { date, _filteredDESK, _filteredROOM } = data;
  const [year, month, day] = date.split('-');

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">
          {variant === 'MONTHLY'
            ? t(
                `common:calendar.months.${monthMap[month as keyof typeof monthMap]}`,
              ) + ` ${year}`
            : `${day}.${month}.${year}`}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{_filteredROOM}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{_filteredDESK}</Typography>
      </TableCell>
    </TableRow>
  );
}
